module.exports = __webpack_public_path__ + "static/media/user.01475cf2.png";